import { render } from "./LeadsListView.vue?vue&type=template&id=f19aaf50"
import script from "./LeadsListView.vue?vue&type=script&lang=js"
export * from "./LeadsListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__